import React from "react"
import { FiStar } from "react-icons/fi"


export const projects = [
    {
        title:'Modern home in city center',
        desc:'2 BEDS - 2 BATHS',
        image:14,
        tags:[],
        category:'PLUS',
        stars:4,
        reviews:34,
    },
    {
        title:'Modern home in city center',
        desc:'2 BEDS - 2 BATHS',
        image:23,
        tags:[],
        category:'PLUS',
        stars:4,
        reviews:34,
    },
    {
        title:'Modern home in city center',
        desc:'2 BEDS - 2 BATHS',
        image:12,
        tags:[],
        category:'PLUS',
        stars:4,
        reviews:34,
    },
    {
        title:'Modern home in city center',
        desc:'2 BEDS - 2 BATHS',
        image:11,
        tags:[],
        category:'PLUS',
        stars:4,
        reviews:34,
    },
    {
        title:'Modern home in city center',
        desc:'2 BEDS - 2 BATHS',
        image:10,
        tags:[],
        category:'PLUS',
        stars:4,
        reviews:34,
    },
    {
        title:'Modern home in city center',
        desc:'2 BEDS - 2 BATHS',
        image:-3,
        tags:[],
        category:'PLUS',
        stars:4,
        reviews:34,
        },
    {
        title:'Modern home in city center',
        desc:'2 BEDS - 2 BATHS',
        image:9,
        tags:[],
        category:'PLUS',
        stars:4,
        reviews:34,
    },
    {
        title:'Modern home in city center',
        desc:'2 BEDS - 2 BATHS',
        image:-1,
        tags:[],
        category:'PLUS',
        stars:4,
        reviews:34,
        },
    {
        title:'Modern home in city center',
        desc:'2 BEDS - 2 BATHS',
        image:18,
        tags:[],
        category:'PLUS',
        stars:4,
        reviews:34,
    },
    {
        title:'Modern home in city center',
        desc:'2 BEDS - 2 BATHS',
        image:6,
        tags:[],
        category:'PLUS',
        stars:4,
        reviews:34,
    }
  ]

export const GridView = () =>{
    return (
        <div className="view_results"> 
            <GridMax />
            <GridMin />
            <List />
        </div>
    )
}

export default GridView

export const List = () => {

    return (
        <ul className="lists">
            { projects.map((grid,i)=>(
                <li className="list" key={'projectlist-grid'+i}>
                <div 
                        className="list_image"
                        style={{
                            backgroundImage:`url("/projects/${grid.image}.jpg")`,
                            backgroundPosition:'center',
                            backgroundSize:'cover',
                        }}
                    />
                    <div className="list_detail">
                        <div className="list_ops">
                            <div>
                                <p className="list_category">{grid.category}</p>
                                <p className="list_desc">{grid.desc}</p>
                            </div>
                            <div className="list_title">{grid.title}</div>
                        </div>
                        <div className="list_stars"> 
                            <div className="stars">
                                <FiStar className="select" />
                                <FiStar className="select" />
                                <FiStar className="select" />
                                <FiStar className="select" />
                                <FiStar className="select" />
                            </div>
                            <p>{grid.reviews} Reviews</p>
                        </div>
                    </div>
                </li>
            ))}
        </ul> 
    )
}

export const GridMin = () => {

    return (
        <ul className="grids3">
            {projects.map((grid,i)=>(
                <li className="grid_box" key={'view_result'+i}>
                    <div 
                        className="grid_image"
                        style={{
                            backgroundImage:`url("/projects/${grid.image}.jpg")`,
                            backgroundPosition:'center',
                            backgroundSize:'cover',
                        }}
                    />

                    <div className="grid_detail">
                        <div className="grid_ops">
                            <div>
                                <p className="grid_category">{grid.category}</p>
                                <p className="grid_desc">{grid.desc}</p>
                            </div>
                            <div className="grid_title">{grid.title}</div>
                        </div>
                        <div className="grid_stars"> 
                            <div className="stars">
                                <FiStar className="select" />
                                <FiStar className="select" />
                                <FiStar className="select" />
                                <FiStar className="select" />
                                <FiStar className="select" />
                            </div>
                            <p>{grid.reviews} Reviews</p>
                        </div>
                    </div>

                </li>
            ))}
        </ul>
    )
}

export const GridMax = () => {

    return (
        <ul className="grids4">
            {projects.map((grid,i)=>(
                <li className="grid_box" key={'grids4'+i}>
                    <div 
                        className="grid_image"
                        style={{
                            backgroundImage:`url("/projects/${grid.image}.jpg")`,
                            backgroundPosition:'center',
                            backgroundSize:'cover',
                        }}
                    />

                    <div className="grid_detail">
                        <div className="grid_ops">
                            <div>
                                <p className="grid_category">{grid.category}</p>
                                <p className="grid_desc">{grid.desc}</p>
                            </div>
                            <div className="grid_title">{grid.title}</div>
                        </div>
                        {/** <div>$1,400 <small>/wk</small></div> **/}
                        <div className="grid_stars"> 
                            <div className="stars">
                                <FiStar className="select" />
                                <FiStar className="select" />
                                <FiStar className="select" />
                                <FiStar className="select" />
                                <FiStar className="select" />
                            </div>
                            <p>{grid.reviews} Reviews</p>
                        </div>
                    </div>

                </li>
            ))}
        </ul>
    )
}